import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

function isAllowedReturnUrl(urlString: string): boolean {
  try {
    const url = new URL(urlString);
    const h = url.hostname;
    return (
      h === "valuegiftvouchers.com" ||
      h === "www.valuegiftvouchers.com" ||
      h.endsWith(".valuegiftvouchers.com") ||
      h === "localhost" ||
      h.endsWith(".localhost")
    );
  } catch {
    return false;
  }
}

export default function LogoutPage() {
  const { signOut } = useAuth();
  const [searchParams] = useSearchParams();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const returnTo = searchParams.get("return_to") ?? "";
    const safeReturn = isAllowedReturnUrl(returnTo) ? returnTo : "/login";
    signOut().then(() => {
      window.location.href = safeReturn;
    });
  }, [signOut, searchParams]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <p className="text-sm text-slate-500 font-medium">Signing out…</p>
    </div>
  );
}
